<app-animal-details-container [animal]="animal()" [partialHeight]="false" [showLocator]="true">
    <div class="d-flex flex-column gap-3">
    <app-profile-picture-editor
        [currentImageUrl]="animal()?.profilePictureUrl"
        (updateImageUrl)="setProfilePictureUrl($event)"/>

    <app-generic-button
        (click)="saveProfilePicture()"
        description="Save changes to animal profile picture"
        [alwaysShowText]="true"
        [disabled]="!updated()"
        [buttonClass]="'btn btn-info btn-info-shadow'"
        [buttonText]="'Save changes'"
        [primaryIcon]="'fa-solid fa-check'"/>
    </div>
</app-animal-details-container>
